import { AiFillLinkedin } from "react-icons/ai";
import { FaInstagram, FaTiktok } from "react-icons/fa";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import {useState, useEffect } from 'react';

function About() {
  const [scrollTop, setScrollTop] = useState(0);
  const scrollDown = () => {
    if (document.documentElement.scrollTop < 800) {
      document.getElementById('faq').scrollIntoView();
    // } else if (document.documentElement.scrollTop < 1500) {
    //   document.getElementById('skills').scrollIntoView();
    } else {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }

  useEffect(() => {
    const handleScroll = (event) => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <main>
      <section className="min-h-screen">
        <div className="text-center mx-auto mt-20 py-5 gap-y-2 leading-8 text-zinc-800 md:text-lg max-w-3xl dark:text-gray-200 transition-colors duration-1000">
          <p className="text-6xl pb-10 font-black">Hello, I'm <span className="text-pink-500"> Kevin</span>!</p>
          <p className="text-3xl font-medium italic">I build software, products, and real-world projects.</p>
          <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>
          <p className="text-2xl pb-5 font-medium">Software Development Engineer @ Amazon</p>
          <p className="text-2xl pb-5 font-medium">UC San Diego Alum</p>
        </div>
        
        <div className="justify-center text-4xl flex gap-16 py-3 text-pink-500">
          <div className="tooltip tooltip-bottom" data-tip="Instagram">
            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/kevintdo/" aria-label="Instagram Profile"><FaInstagram /></a>
          </div>
          <div className="tooltip tooltip-bottom" data-tip="LinkedIn">
            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/kevintdo50/" aria-label="Linkedin Profile"><AiFillLinkedin /></a>
          </div>
          <div className="tooltip tooltip-bottom" data-tip="TikTok">
            <a target="_blank" rel="noreferrer" href="https://www.tiktok.com/@kevindough" aria-label="TikTok Profile"><FaTiktok /></a>
          </div>
          {/* <div className="tooltip tooltip-bottom" data-tip="Email">
            <a target="_blank" rel="noreferrer" href="mailto:kevin12345do@gmail.com" aria-label="Email Link"><MdMail /></a>
          </div> */}
        </div>
        
        {/* <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/> */}
        {/* <div className="justify-center flex py-3 mt-12">
            <a href="#faq" className="bg-pink-500 p-3 px-4 rounded-full flex items-center text-white font-bold">Personal Insights</a>
          
        </div> */}
      </section>
      {/* <p className=" text-white fixed bottom-32 right-12">{scrollTop}</p> */}
          <IoIosArrowDropdownCircle id="scrollButton" onClick={scrollDown} className={`${scrollTop >= 800 ? "rotate-180" : ""} bottom-12 right-12 fixed text-black dark:text-white dark:hover:text-pink-500 hover:text-pink-500 hover:scale-150 delay-200 text-3xl lg:text-4xl transition ease-in-out duration-200 hidden sm:inline`}/>
      <section id="faq" className="min-h-screen pb-10">
        
        <div className="pt-16 text-black dark:text-white transition-colors duration-1000">
          <div className="max-w-6xl mb-12 mx-auto text-center">
            <h1 className='text-5xl flex justify-center font-extrabold text-black dark:text-white transition-colors duration-1000'>About Me</h1>
            <p className="text-2xl pt-4 font-medium">
              My drive is fueled by the ability to be <span className="underline decoration-pink-500 underline-offset-2">hands-on</span>, employ my <span className="underline decoration-pink-500 underline-offset-2">creativity</span>, and create <span className="underline decoration-pink-500 underline-offset-2">functional</span> products.
            </p>
            <p className="text-2xl pt-4 font-medium">
              I want to be consistent with documenting my journey, which includes my side projects, insights, and lifestyle.
            </p>
          </div>

          <h1 className='text-4xl flex justify-center font-extrabold text-black dark:text-white transition-colors duration-1000'>Interests</h1>

          <div className='py-5 flex gap-5 flex-wrap'>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">🚗 Cars & Modding</h2>  
              </div>
            </div>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">💻 Building Apps</h2>  
              </div>
            </div>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">🏋️ Gym & Sports</h2>  
              </div>
            </div>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">📱 Consumer Tech</h2>  
              </div>
            </div>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">🎨 Doodle Art</h2>  
              </div>
            </div>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">🌿 Fragrances</h2>  
              </div>
            </div>

            <div className="card card-compact w-[23rem] bg-zinc-200 shadow-md dark:bg-zinc-800 transition-colors duration-1000">
              <div className="card-body text-zinc-900 dark:text-white transition-colors duration-1000">
                <h2 className="card-title justify-center">📷 Making Videos</h2>  
              </div>
            </div>



          </div>

          {/* <div className="justify-center flex py-3 mt-12">
            <p>
                <a href="/now" className="bg-pink-500 p-3 px-4 rounded-full text-white font-bold" >Now Page</a>
            </p>
          </div> */}

          {/* <ul className="max-w-4xl mx-auto mt-12 divide-y bg-zinc-300 dark:bg-zinc-800 rounded-xl">
            
            <li>
                <details className="group">
                    <summary className="flex flex-row items-center gap-3 px-4 py-3 font-medium marker:content-none">
                        <IoIosArrowDropdownCircle className={`flex-none -rotate-90 group-open:rotate-0 text-black dark:text-white hover:scale-110 dark:hover:text-pink-500 hover:text-pink-500 delay-100 text-3xl transition ease-in-out duration-200`}/>
                        <span>What is your strength?</span>
                    </summary>

                    <article className="px-4 pb-4">
                        <p>
                            My strength is being creative. This allows me to see things from different perspectives.
                            Therefore, I am curious and question things, taking unique approaches to problems.
                            An example of this would be in the Successorator project. When there are no goals in the list, the 
                            app should display a message saying that there are no goals. However, this should dissapear 
                            when there are goals. My solution was to make the background color of the goal list change from transparent 
                            to white when there are goals. This way, the message is hidden when there are goals and shown when there are none.
                            This means that I did not have to make an observer to check if the goals list was empty or not since the text was 
                            in a completely different fragment.
                        </p>
                    </article>
                </details>
            </li>

            <li>
                <details className="group">
                    <summary className="flex items-center gap-3 px-4 py-3 font-medium marker:content-none">
                        <IoIosArrowDropdownCircle className={`flex-none -rotate-90 group-open:rotate-0 text-black dark:text-white hover:scale-110 dark:hover:text-pink-500 hover:text-pink-500 delay-100 text-3xl transition ease-in-out duration-200`}/>
                        <span>What is your weakness?</span>
                    </summary>

                    <article className="px-4 pb-4">
                        <p>
                            My weakness is being too detail-oriented. This can lead to me spending too much time on a single task. When I was creating the live 
                            audio waveform for the Vetscribe app, I was too focused on making the waveform functional. I was trying to make it be scrollable 
                            like with voice memo apps. However, this voice recorder wouldn't have the functionality to rerecord certain parts of the audio, so scrolling 
                            through the waveform would be unnecessary. The purpose of the waveform was to show the user that the audio was being recorded. In order to 
                            work through this weakness I need to look at the bigger picture and set priorities for the task at hand.
                        </p>
                    </article>
                </details>
            </li>

            <li>
                <details className="group">
                    <summary className="flex items-center gap-3 px-4 py-3 font-medium marker:content-none">
                        <IoIosArrowDropdownCircle className={`flex-none -rotate-90 group-open:rotate-0 text-black dark:text-white hover:scale-110 dark:hover:text-pink-500 hover:text-pink-500 delay-100 text-3xl transition ease-in-out duration-200`}/>
                        <span>What is a time you had to resolve a team conflict?</span>
                    </summary>

                    <article className="px-4 pb-4">
                        <p>
                            During the Successorator project in the class CSE 110, there was a conflict between me and my pair programming partner about 
                            splitting work and doing our fair share of work. I talked with him about it and I found out that he didn't understand how to 
                            do the code or work in Android Studio. In order to resolve this I offered to help him by providing him resources that I had used to learn 
                            such as the labs we did in class and I also guided him through the code I wrote and explained it. I think this was helpful for him because 
                            he was able to contribute to a ticket in the end.
                        </p>
                    </article>
                </details>
            </li>

            <li>
                <details className="group">
                    <summary className="flex items-center gap-3 px-4 py-3 font-medium marker:content-none">
                        <IoIosArrowDropdownCircle className={`flex-none -rotate-90 group-open:rotate-0 text-black dark:text-white hover:scale-110 dark:hover:text-pink-500 hover:text-pink-500 delay-100 text-3xl transition ease-in-out duration-200`}/>
                        <span>What is a time you had to learn a skill in a short period of time?</span>
                    </summary>

                    <article className="px-4 pb-4">
                        <p>
                            In the Opinions hackathon project, our group created an iOS app that also implemented OpenAI LLM API. This was very new to me since 
                            the last time I had made an iOS app was in 10th grade in high school and I haven't really used the APIs for ChatGPT. By reading documentation 
                            and asking more experienced teammates, I was able to quickly understand and get on the same page as the others. I learned basics of Swift and 
                            also how to basically use ChatGPT with python. It was important for me to try to figure it out on my own first and exhaust my online resources before 
                            I asked my teammates so that I didn't ask too many questions and distract them from their work. 
                        </p>
                    </article>
                </details>
            </li>
            

        </ul> */}

        </div>
      </section>
    </main>
  )
}

export default About